export const Layouts = {
  MaxMainContentWidth: '1200px',
  MinMainContentWidth: '700px',
  HeatMap: {
    CellHeight: '60px',
    CellMinWidth: '110px'
  }
}
